var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Box, Chip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from "dayjs";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { stockTransferPagingAPI } from "../../../api/url";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { DesktopTabComponent } from "../../../components/molecules/desktopTabComponent";
import { ESystemName, LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { secondaryTextGray } from "../../../theme/palette";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate, GoogleAnlyticsErrorLog } from "../../../utils/utils";
import { DownloadIconSVG, PrintIconSVG, ShareIcon } from "../../spareParts/purchaseRequistion/assets/customIcons";
import { MoreDetails } from "../../stockTransferRequistion/components/moreDetails.stockTransferRequisition";
import { stockTransferCreate, StockTransferPaging, stockTransferRequisitionWithDetailsAPIGet } from "../apiCall";
import { StockTransferFilter } from "../components/stockTransferFilter";
import { StockTransferAPIKeys } from "../entity";
import HeaderCatalogPageComponent from "../../../components/templates/headerCatalogPageUpdated";
export var StockTransferList = function () {
    var _getLocalStorageItem, _crud$filterValue;
    var navigate = useNavigate();
    var getStockTransferList = useAppSelector(function (state) { return state.crud; }).getStockTransferList;
    var isAllViewActive = useAppSelector(function (state) { return state.common; }).isAllViewActive;
    var crud = useAppSelector(function (state) { return state.crud; });
    var listVariants = ["My Transfers", "All Transfers"];
    var _a = useState('list'), activeView = _a[0], setActiveView = _a[1];
    var _b = useState(false), openFilter = _b[0], setOpenFilter = _b[1];
    var _c = useState(null), rowData = _c[0], setRowData = _c[1];
    var _d = useState(false), openDrawer = _d[0], setOpenDrawer = _d[1];
    var _e = useState(listVariants.length > 0 && isAllViewActive ? listVariants[0] : listVariants[1]), selectedListVariant = _e[0], setSelectedListVariant = _e[1];
    var dispatch = useAppDispatch();
    var storedMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE);
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var filterValue = (_crud$filterValue = crud['filterValue']) === null || _crud$filterValue === void 0 ? void 0 : _crud$filterValue.data;
    var profileData = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA);
    var getRequest = function () {
        var _filterValue$Status, _getLocalStorageItem2;
        var request = {
            Type: 'StockTransfer',
            SourceTenantId: UserOrganization,
            FromDate: filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            ToDate: filterValue !== null && filterValue !== void 0 && filterValue.ToDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.ToDate : filterValue !== null && filterValue !== void 0 && filterValue.FromDate ? filterValue === null || filterValue === void 0 ? void 0 : filterValue.FromDate : "",
            Status: filterValue === null || filterValue === void 0 || (_filterValue$Status = filterValue.Status) === null || _filterValue$Status === void 0 ? void 0 : _filterValue$Status.map(function (item) { return item === null || item === void 0 ? void 0 : item.Name; }),
            IdentityId: selectedListVariant === "My Transfers" ? (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.IdentityId : undefined,
            take: 10,
            skip: 0
        };
        if (filterValue !== null && filterValue !== void 0 && filterValue.SourceWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                SourceWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.SourceWarehouseId
            });
        }
        if (filterValue !== null && filterValue !== void 0 && filterValue.DestinationWarehouseId) {
            request = _objectSpread(_objectSpread({}, request), {}, {
                DestinationWarehouseId: filterValue === null || filterValue === void 0 ? void 0 : filterValue.DestinationWarehouseId
            });
        }
        return request;
    };
    useEffect(function () {
        StockTransferPaging({
            key: StockTransferAPIKeys.paging,
            request: getRequest(),
            url: stockTransferPagingAPI
        });
    }, [selectedListVariant, filterValue]);
    var getIcon = function (name) {
        switch (name) {
            case 'Print':
                return /*#__PURE__*/ React.createElement(PrintIconSVG, {
                    id: "stockTransferRequi-print-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'DownloadPDF':
                return /*#__PURE__*/ React.createElement(DownloadIconSVG, {
                    id: "stockTransferRequi-print-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            case 'SendForApproval':
                return /*#__PURE__*/ React.createElement(ShareIcon, {
                    id: "stockTransferRequi-share-icon",
                    sx: {
                        color: secondaryTextGray,
                        width: 16,
                        height: 16
                    }
                });
            default:
                return /*#__PURE__*/ React.createElement(React.Fragment, null);
        }
    };
    var handleSelectMenu = function (listVariant) {
        setSelectedListVariant(listVariant);
    };
    var onToggleViewChange = function (value) {
        setActiveView(value);
    };
    var onClickCreateModule = function () {
        navigate("/createStockTransfer?mode=add");
    };
    var handleClickFilterIcon = function () {
        setOpenFilter(function (prev) { return !prev; });
    };
    var handleRowClick = function (row) {
        setRowData(row);
        setOpenDrawer(true);
    };
    var handleDrawerClose = function () {
        setRowData(undefined);
        setOpenDrawer(false);
    };
    var handleSendForApprovalClick = function (params) { return __awaiter(void 0, void 0, void 0, function () {
        var _params$row, id, res, updatedData, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    id = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.id;
                    return [4 /*yield*/, stockTransferRequisitionWithDetailsAPIGet({
                            request: {
                                id: id
                            }
                        })];
                case 1:
                    res = _a.sent();
                    if (!((res === null || res === void 0 ? void 0 : res.success) === true)) return [3 /*break*/, 3];
                    updatedData = _objectSpread(_objectSpread({}, res.data), {}, {
                        Status: "Completed"
                    });
                    return [4 /*yield*/, stockTransferCreate({
                            request: updatedData
                        })];
                case 2:
                    response = _a.sent();
                    if ((response === null || response === void 0 ? void 0 : response.success) === true) {
                        dispatch(showNotification({
                            isOpen: true,
                            message: t("Successfully Sent For Approval"),
                            type: "success"
                        }));
                    }
                    else {
                        GoogleAnlyticsErrorLog(profileData, 'ClientSide', "Failed To Send For Approval");
                        dispatch(showNotification({
                            isOpen: true,
                            message: 'Failed To Send For Approval',
                            type: "error"
                        }));
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var customActionColumns = [{
            field: 'DocumentCode',
            headerName: 'Document Id',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 200
        }, {
            field: 'ExpectedTransferDate',
            headerName: 'Transfer date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.ExpectedTransferDate ? "".concat(dateFormate(dayjs(row === null || row === void 0 ? void 0 : row.ExpectedTransferDate))) : '-'; },
            minWidth: 150
        }, {
            field: 'RecordedByGivenName',
            headerName: 'Created by',
            align: 'center',
            valueFormatter: function (val, row) {
                var _row$RecordedByGivenN, _row$RecordedByFamily;
                return row !== null && row !== void 0 && row.RecordedByGivenName || row !== null && row !== void 0 && row.RecordedByFamilyName ? "".concat((_row$RecordedByGivenN = row === null || row === void 0 ? void 0 : row.RecordedByGivenName) !== null && _row$RecordedByGivenN !== void 0 ? _row$RecordedByGivenN : ' ', "  ").concat((_row$RecordedByFamily = row === null || row === void 0 ? void 0 : row.RecordedByFamilyName) !== null && _row$RecordedByFamily !== void 0 ? _row$RecordedByFamily : ' ') : '-';
            },
            minWidth: 150
        }, {
            field: 'CreatedOn',
            headerName: 'Created date',
            valueFormatter: function (val, row) { return row !== null && row !== void 0 && row.CreatedOn ? "".concat(dateFormate(row === null || row === void 0 ? void 0 : row.CreatedOn)) : '-'; },
            minWidth: 150
        }, {
            field: 'SourceWarehouseName',
            headerName: 'Warehouse',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            field: 'TotalQuantity',
            headerName: 'Total qty',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 100
        }, {
            field: 'StatusName',
            headerName: 'Status',
            minWidth: 150,
            renderCell: function (params) {
                var _params$row2, _params$row$StatusNam, _params$row3;
                return (params === null || params === void 0 || (_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.StatusName) && /*#__PURE__*/ React.createElement(Chip, {
                    label: (_params$row$StatusNam = params === null || params === void 0 || (_params$row3 = params.row) === null || _params$row3 === void 0 ? void 0 : _params$row3.StatusName) !== null && _params$row$StatusNam !== void 0 ? _params$row$StatusNam : '-',
                    size: "small",
                    variant: "outlined",
                    sx: {
                        borderRadius: 2,
                        px: 1,
                        fontWeight: 500,
                        fontSize: 12,
                        color: 'black'
                    },
                    icon: /*#__PURE__*/ React.createElement(Box, {
                        height: 8,
                        width: 8,
                        borderRadius: 10,
                        bgcolor: "gray"
                    })
                });
            }
        }, {
            field: 'TotalAmount',
            headerName: 'Total amount (₹)',
            valueFormatter: function (val) { return val !== null && val !== void 0 ? val : '-'; },
            minWidth: 150
        }, {
            type: 'actions',
            field: 'actions',
            headerName: '',
            getActions: function (params) {
                var _storedMenuFeatures$f, _storedMenuFeatures$f2;
                return (_storedMenuFeatures$f = storedMenuFeatures === null || storedMenuFeatures === void 0 || (_storedMenuFeatures$f2 = storedMenuFeatures.filter(function (data) {
                    var _params$row4;
                    if ((data === null || data === void 0 ? void 0 : data.Name) === 'SendForApproval' && (params === null || params === void 0 || (_params$row4 = params.row) === null || _params$row4 === void 0 ? void 0 : _params$row4.StatusName) !== 'Draft') {
                        return false;
                    }
                    return true;
                })) === null || _storedMenuFeatures$f2 === void 0 ? void 0 : _storedMenuFeatures$f2.map(function (data) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    key: data === null || data === void 0 ? void 0 : data.Name,
                    label: data === null || data === void 0 ? void 0 : data.DisplayName,
                    icon: getIcon(data === null || data === void 0 ? void 0 : data.Name),
                    showInMenu: true,
                    onClick: function () {
                        var _params$row5;
                        if ((data === null || data === void 0 ? void 0 : data.Name) === 'SendForApproval' && (params === null || params === void 0 || (_params$row5 = params.row) === null || _params$row5 === void 0 ? void 0 : _params$row5.StatusName) === 'Draft') {
                            handleSendForApprovalClick(params);
                        }
                    }
                }); })) !== null && _storedMenuFeatures$f !== void 0 ? _storedMenuFeatures$f : [];
            },
            flex: 1
        }];
    var handleRowEditClick = function (id) {
        stockTransferRequisitionWithDetailsAPIGet({
            request: {
                id: id
            }
        });
        navigate("/createStockTransfer/".concat(id, "?mode=edit"));
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, {
        items: listVariants
    }), /*#__PURE__*/ React.createElement(HeaderCatalogPageComponent, {
        handleClickFilterIcon: handleClickFilterIcon,
        selectedMenuItem: selectedListVariant,
        menus: listVariants.length > 0 ? listVariants : undefined,
        onSelectMenu: handleSelectMenu,
        activeView: activeView,
        onToggleView: onToggleViewChange,
        totalCount: getStockTransferList === null || getStockTransferList === void 0 ? void 0 : getStockTransferList.TotalCount,
        onClickCreateModule: onClickCreateModule,
        createButtonText: "New",
        isCreateButton: true,
        moduleName: ESystemName.StockTransfer,
        title: "Stock Transfer"
    }), /*#__PURE__*/ React.createElement(Box, {
        p: 2
    }, /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        getPagingData: StockTransferPaging,
        pagingAPIKey: StockTransferAPIKeys.paging,
        pagingAPIRequest: getRequest(),
        columns: customActionColumns,
        dataGridProps: {
            paginationMode: 'client',
            onRowClick: handleRowClick
        }
    })), /*#__PURE__*/ React.createElement(MoreDetails, {
        handleRowEditClick: handleRowEditClick,
        handleDrawerClose: handleDrawerClose,
        openDrawer: openDrawer,
        rowData: rowData,
        isEditable: false
    }), /*#__PURE__*/ React.createElement(StockTransferFilter, {
        isFilterOpen: openFilter,
        setFilterOpen: handleClickFilterIcon
    }));
};
